<template>
  <e-modal
    :visible="visible"
    :title="title"
    :width="900"
    :loading="loading"
    @close="onClose"
    @ok="onSubmit"
  >
    <a-spin tip="Loading..." :spinning="loading">
      <ChooseAudios v-model:value="list" title="编辑音频" />
    </a-spin>
  </e-modal>
</template>

<script>
import { defineComponent, ref } from 'vue'
import form from '@/mixins/form'
import ChooseAudios from '@/components/form/ChooseAudios.vue'

export default defineComponent({
  components: {
    ChooseAudios
  },
  mixins: [form],
  emits: ['ok'],
  setup (props, { emit }) {
    const loading = ref(false)
    const visible = ref(false)
    const title = ref('')
    const list = ref([])
    const field = ref('')

    const onClose = () => {
      list.value = []
      field.value = ''
      loading.value = false
      visible.value = false
    }

    return {
      title,
      visible,
      loading,

      list,
      field,

      onClose
    }
  },

  methods: {
    open (pic, title, field, orderId) {
      this.list = pic ? pic.split(',') : []

      console.log(this.list, pic)
      this.title = title
      this.field = field
      this.orderId = orderId
      this.visible = true
    },

    onSubmit () {
      this.$emit('ok', {
        field: this.field,
        data: this.list.length > 0 ? this.list.join(',') : ''
      })
    }
  }
})
</script>
